const sourceObj = {
  dataoke: '大淘客',
  smzdm: '什么值得买',
  baicaio: '白菜哦',
  cqp: '酷Q',
}

// 占位     
export function formatEmpty(a, b) {
  return a ? a : ( b ? b: '-')
}

// 百分比   50 => 50%
export function formatRatio(value) {
  return value ? value + '%' : undefined
}

// 比例     100 999 => 100/999
export function formatPercentum(a, b) {
  return a&&b ? a+' / '+b : undefined
}

// 格式化 来源
export function formatSource(value) {
  return sourceObj[value] ? sourceObj[value] : undefined
}

